import React from 'react'
import { formatAddress } from 'helpers/format'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'

type Props = {
  merchant?: any
  hasFullAddress?: boolean
}

const PdfCompanyInfo: React.FunctionComponent<Props> = props => {
  const { merchant, hasFullAddress = false } = props

  return (
    <div>
      <CompanyName>{merchant?.name}</CompanyName>
      <CompanyInfo>
        {hasFullAddress
          ? merchant?.address
          : formatAddress(
              merchant?.address,
              merchant?.district,
              merchant?.amphor,
              merchant?.province,
              merchant?.postcode,
            )}
      </CompanyInfo>
      <CompanyInfo>เบอร์โทรศัพท์ {merchant?.phone}</CompanyInfo>
      {/* <CompanyInfo>เลขประจำตัวผู้เสียภาษี </CompanyInfo> */}
    </div>
  )
}

const CompanyName = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.h5};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.medium};
`

const CompanyInfo = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.medium};
`

export default PdfCompanyInfo
